'use strict';
import React from 'react';
import {AvatarColors} from '../../core-utilities/domain/AvatarColors';

export function InitialsAvatar(assignedTo) {
  const avatarClass = assignedTo ? AvatarColors.getColorClass(assignedTo.avc) : 'no-assignedTo-color';
  // this is intentionally not a normal ternary statement so that if assignedTo.avi is not truthy it falls back to the default
  const initials = assignedTo && assignedTo.avi || '-';
  return (
    <span className={'avatar-calendar ' + avatarClass}>
      {initials}
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/js/calendar/components/InitialsAvatar.js